type ResolveApiBaseUrlParams = {
  apiBaseUrl?: string | null;
  apiUrl?: string | null;
  isDev?: boolean;
  devFallbackUrl?: string | null;
  appendApiV1?: boolean;
};

function normalizeUrl(value?: string | null): string {
  return String(value ?? '').trim().replace(/\/+$/, '');
}

export function resolveApiBaseUrl(params: ResolveApiBaseUrlParams): string {
  const explicitBaseUrl = normalizeUrl(params.apiBaseUrl);
  const explicitApiUrl = normalizeUrl(params.apiUrl);
  const fallbackUrl = params.isDev ? normalizeUrl(params.devFallbackUrl) : '';
  const baseUrl = explicitBaseUrl || explicitApiUrl || fallbackUrl;

  if (!baseUrl) {
    return '';
  }

  if (!params.appendApiV1) {
    return baseUrl;
  }

  return baseUrl.endsWith('/api/v1') ? baseUrl : `${baseUrl}/api/v1`;
}
